export default __webpack_public_path__ + "0c9332b4bb6210895850dcf31aeccefa.jpg";